import { useContext, useState } from "react"
import { AppLink, AppSpan, AppText, Button, CustomContainer, FlexRow, GridContainer, ScreenTitle } from "src/style"
import { AppCenterPopupD2, CenterPopupHeaderD2, RepayLoan, RepaymentSchedule, SidePopupLayout } from "src/component"
import { moneyFormat } from "src/utils/utility"
import ApiContext from "src/provider/API/call-service"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"
import { Design } from "src/model"

export const LoanDetails: React.FC<any> = ({data, close}:{data: LoanDetail, close: ()=>void}) => {
    const {API} = useContext(ApiContext)
    const {info: {institutionData}} = useContext(AppInfoContext)

    const [view, setView] = useState('loan-details')
    const [repaymentSchedule, setRepaymentSchedule] = useState<any[]>([])

    async function handleGetLoanRepaymentSchedule() {
       const response = await API.getLoanRepaymentSchedule({LoanAccountNumber: data.number})
       if(response){
           setRepaymentSchedule(response)
           setView('repayment-schedule')
        }
    }

    const dispPercent = ((data.totalRepaymentAmount - data.amountLeft)/data.totalRepaymentAmount)*100
    const widthPercent = (dispPercent > 80 ? dispPercent - 20 : dispPercent < 20 ? dispPercent + 20 : dispPercent).toString()


    const Container =({children}:{children: React.ReactNode}) => {
        switch(true){
            case institutionData.design === Design.DESIGN_2:
                return  (
                    <AppCenterPopupD2  zIndex='6' overflow='hidden' close={close}>
                        <CenterPopupHeaderD2 title='Loan Details' close={close} />
                        {children}
                    </AppCenterPopupD2>)
            default:
                return( 
                    <SidePopupLayout close={close}>
                        <ScreenTitle textSize="2.2" fontWeight="700">Loan Details</ScreenTitle>
                        {children}
                    </SidePopupLayout>)
        }
    }

    return (
        <>
            { view === 'loan-details' &&
                <Container>
                    <CustomContainer topMargin="3">
                        <CustomContainer
                            minHeight="19.6" borderColor="#EAECF0" padding="2" radius="0.8"
                        >
                            <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                                <GridContainer width="auto" sizeUnit="" alignItems="start">
                                    <AppSpan>Loan Type</AppSpan>
                                    <AppText fontWeight="700" color="#0D968F" fontFamily="Gilmer-Bold">{!!data.product ? data.product : '--'}</AppText>
                                </GridContainer>
                                <GridContainer width="auto" sizeUnit="" alignItems="end">
                                    <AppSpan>Loan Amount</AppSpan>
                                    <AppText fontWeight="700" color="#0D968F" fontFamily="Gilmer-Bold">{moneyFormat(data.loanAmount, true,institutionData?.defaultCurrency)}</AppText>
                                </GridContainer>
                            </FlexRow>
                            <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                                <GridContainer width="auto" sizeUnit="" alignItems="start">
                                    <AppSpan>Tenure</AppSpan>
                                    <AppText fontWeight="700" color="#0D968F" fontFamily="Gilmer-Bold">{data.loanCycle} Days</AppText>
                                </GridContainer>
                                <GridContainer width="auto" sizeUnit="" alignItems="end">
                                    <AppSpan>Interest</AppSpan>
                                    <AppText fontWeight="700" color="#0D968F" fontFamily="Gilmer-Bold">{data.interestRate}%</AppText>
                                </GridContainer>
                            </FlexRow>
                            <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                                <GridContainer width="auto" sizeUnit="" alignItems="start">
                                    <AppSpan>Monthly Interest Rate</AppSpan>
                                    <AppText fontWeight="700" color="#0D968F" fontFamily="Gilmer-Bold">{!!data.monthlyInterestRate ? data.monthlyInterestRate : '--'}</AppText>
                                </GridContainer>
                                <GridContainer width="auto" sizeUnit="" alignItems="end">
                                    <AppSpan>Amount Left</AppSpan>
                                    <AppText fontWeight="700" color="#0D968F" fontFamily="Gilmer-Bold">{moneyFormat(data.amountLeft, true,institutionData?.defaultCurrency)}</AppText>
                                </GridContainer>
                            </FlexRow>
                            <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                                <GridContainer width="auto" sizeUnit="" alignItems="start">
                                    <AppSpan>Next Payment Date</AppSpan>
                                    <AppText fontWeight="700" color="#0D968F" fontFamily="Gilmer-Bold">{!!data.nextPaymentDate ? data.nextPaymentDate : '--'}</AppText>
                                </GridContainer>
                                <GridContainer width="auto" sizeUnit="" alignItems="end">
                                    <AppSpan>Maturity Date</AppSpan>
                                    <AppText fontWeight="700" color="#0D968F" fontFamily="Gilmer-Bold">{data.maturityDate}</AppText>
                                </GridContainer>
                            </FlexRow>
                            <FlexRow justifyContent="space-between" gap="1.5" topMargin="1.5" wrap="wrap">
                                <GridContainer width="auto" sizeUnit="" alignItems="start">
                                    <AppSpan>Total Repayment Amount</AppSpan>
                                    <AppText fontWeight="700" color="#0D968F" fontFamily="Gilmer-Bold">{moneyFormat(data.totalRepaymentAmount, true,institutionData?.defaultCurrency)}</AppText>
                                </GridContainer>
                            </FlexRow>
                            <GridContainer
                                bgColor="rgba(13, 150, 143, 0.07)"
                                radius="0.5" height="2.6" topMargin="1.5"
                            >
                                <FlexRow justifyContent="space-between" rightPadding="1">
                                    <GridContainer 
                                        height="2.6" bgColor="#0D968F" radius="0.5" 
                                        width={widthPercent} sizeUnit="%" leftPadding="1" rightPadding="1"
                                    >
                                        <AppText textSize="0.9" fontWeight="500" color="#ffffff">
                                            {moneyFormat(Number(data.totalRepaymentAmount) - Number(data.amountLeft), true,institutionData?.defaultCurrency)}
                                        </AppText>
                                    </GridContainer>
                                    <AppText textSize="0.9" fontWeight="600" color="#0D968F">{moneyFormat(data.totalRepaymentAmount, true,institutionData?.defaultCurrency)}</AppText>
                                </FlexRow>
                            </GridContainer>
                            <GridContainer topMargin="1.5">
                                <AppLink 
                                    decoration="none" fontFamily="Gilmer-Bold" color="#0D968F"
                                    fontWeight="700" hoverColor="#667085"
                                    onClick={handleGetLoanRepaymentSchedule}
                                >
                                    View Repayment Schedule
                                </AppLink>
                            </GridContainer>
                        </CustomContainer>
                        <FlexRow justifyContent='flex-end' gap="1.5" topMargin="2.5">
                            <Button 
                                width='13.9' height='4' 
                                borderColor='#0D968F' hoverBgColor='#ffffff' 
                                hoverColor='#0D968F' titleSize='1.4'
                                onClick={() => setView('repay_loan')}
                            >
                                Repay Loan
                            </Button>
                        </FlexRow>
                    </CustomContainer>
                </Container>
            }
            { view === 'repayment-schedule' &&
                <RepaymentSchedule 
                    close={close}
                    repaymentSchedule={repaymentSchedule}
                    details={data}
                />
            }
            { view === 'repay_loan' &&
                <RepayLoan 
                    close={close}
                    back={() => setView('loan-details')}
                    details={data}
                />
            }
        </>
    )
}

type LoanDetail = {
    number: number
    product: string
    loanAmount: number
    loanCycle: number
    interestRate: number
    monthlyInterestRate: number
    amountLeft: number
    nextPaymentDate: string
    maturityDate: string
    totalRepaymentAmount: number
    realLoanStatus: string
}